export class AccountRelationModel {
    ownerAccountId;
    subAccountId;
    searchable;
    accessible;
    createdDate;
    lastUpdatedDate;
    lastUpdaterUserId;
    type;
}
export class AccountModel {
    accountId;
    accountName;
    active;
    esIndexPrefix;
    maxDailyGB;
    reservedDailyGB;
    isFlexible;
    retentionDays;
    accountToken;
}
export class DetailedAccountModel {
    account;
    subAccountRelation;
    isCapped;
    sharingObjectsAccounts = [];
    utilizationSettings;
    dailyUsagesList;
    docSizeSetting;
    softLimitGB;
    snapSearchRetentionDays;
}
export class AccountRetentionDetailsModel {
    accountId;
    retentionDays;
    snapSearchRetentionDays;
}
//# sourceMappingURL=detailed-account.js.map